(function (){
  'use strict';

  angular
      .module('tfc.retailer.StandardReports')
      .factory('ComparisonsConfig', ComparisonsConfig);

  function ComparisonsConfig(PageConfig, Section, Chart, SeriesService, CalloutLabelService, UserCohort,
                              ConsumerChartDisplay, StandardReports){

    var conversion = function (page) {
      return Section("conversion", page,
          Chart("conversion", "line", "percent", false,
              [ SeriesService.tf({ userCohort: UserCohort.tf.value}),
                SeriesService.nonTF({ userCohort: UserCohort.nonTF.value }),
                SeriesService.sitewide({ userCohort: UserCohort.all.value }),
              ]
          ),
          [ StandardReports.calloutOptions("Conversion", [ CalloutLabelService.tf(false),
              CalloutLabelService.nonTF(false), CalloutLabelService.sitewide(false)])],
          StandardReports.sectionOptions('conversions',null, '%')
      );
    };

    var orders = function(page) {
      return Section("orders", page,
          Chart("orders", "line", "values", false,
              [SeriesService.tf({userCohort: UserCohort.tf.value, isBot: false, isMatched: true}),
                SeriesService.nonTF({userCohort: UserCohort.nonTF.value, isBot: false, isMatched: true}),
                SeriesService.sitewideWithBots({})]
          ),
          [StandardReports.calloutOptions("TotalUsedForReporting", [CalloutLabelService.tf(true), CalloutLabelService.nonTF(true)]),
            StandardReports.calloutOptions("TotalReporting", [CalloutLabelService.sitewideWithBots(true)])],
          StandardReports.sectionOptions('orders')
      );
    };

    var sessions = function(page) {
      return Section("sessions", page,
          Chart("sessions", "line", "values", false,
              [SeriesService.tf({userCohort: UserCohort.tf.value, isBot: false}),
                SeriesService.nonTF({userCohort: UserCohort.nonTF.value, isBot: false}),
                SeriesService.sitewideWithBots({})]
          ),
          [StandardReports.calloutOptions("TotalUsedForReporting", [CalloutLabelService.tf(true), CalloutLabelService.nonTF(true)]),
            StandardReports.calloutOptions("TotalReporting", [CalloutLabelService.sitewideWithBots(true)])],
          StandardReports.sectionOptions('sessions')
      );
    };

    var revenue = function (page) {
      return Section("revenue", page,
          Chart("revenue", "line", "values", false,
              [ SeriesService.tf(function(v){ return v.userCohort === UserCohort.tf.value && !v.isBot && _.isUndefined(v.isMatched) }),
                SeriesService.nonTF(function(v){ return v.userCohort === UserCohort.nonTF.value && !v.isBot && _.isUndefined(v.isMatched) }),
                SeriesService.sitewideWithBots(function(v){ return v.userCohort === UserCohort.all.value && _.isUndefined(v.isMatched) })
              ]
          ),
          [ StandardReports.calloutOptions("TotalRevenue",
              [ CalloutLabelService.tf(true), CalloutLabelService.nonTF(true), CalloutLabelService.sitewideWithBots(false)])
          ],
          StandardReports.sectionOptions('revenue', '$')
      );
    };

    var mau = function (page) {
      return Section("mau", page,
          Chart("mau", "line", "values", false,
              [ SeriesService.tf({ userCohort: UserCohort.tf.value, isBot: false }),
                SeriesService.nonTF({ userCohort: UserCohort.nonTF.value, isBot: false }),
                SeriesService.sitewideWithBots({ userCohort: UserCohort.all.value })
              ]
          ),
          [ StandardReports.calloutOptions("MeanUserCount", [ CalloutLabelService.tf(true), CalloutLabelService.nonTF(true),
            CalloutLabelService.sitewideWithBots(false)]) ],
          StandardReports.sectionOptions('monthly-users')
      );
    };

    var dau = function (page) {
      return Section("dau", page,
          Chart("dau", "line", "values", false,
              [ SeriesService.tf({ userCohort: UserCohort.tf.value, isBot: false }),
                SeriesService.nonTF({ userCohort: UserCohort.nonTF.value, isBot: false }),
                SeriesService.sitewideWithBots({ userCohort: UserCohort.all.value })
              ]
          ),
          [ StandardReports.calloutOptions("MeanUserCount", [ CalloutLabelService.tf(true), CalloutLabelService.nonTF(true),
            CalloutLabelService.sitewideWithBots(false)]) ],
          StandardReports.sectionOptions('daily-users')
      );
    };

    var spu = function (page) {
      return Section("spu", page,
          Chart("spu", "line", "ratio", false,
              [ SeriesService.tf({ userCohort: UserCohort.tf.value}),
                SeriesService.nonTF({ userCohort: UserCohort.nonTF.value}),
                SeriesService.sitewide({ userCohort: UserCohort.all.value}),
              ]
          ),
          [ StandardReports.calloutOptions("MeanSPU", [ CalloutLabelService.tf(false), CalloutLabelService.nonTF(false),
            CalloutLabelService.sitewide(false)]) ],
          StandardReports.sectionOptions('sessions-per-user')
      );
    };

    var adoption = function (page) {
      return Section("adoption", page,
          Chart("adoption", "line", "percent", false, [ SeriesService.tf() ]),
          [ StandardReports.calloutOptions("TFPercent", [ CalloutLabelService.tf(false) ], true) ],
          StandardReports.sectionOptions('tf-users-percent', null, '%')
      );
    };

    var newUsers = function (page) {
      return Section("newUsers", page,
          Chart("newUsers", "line", "values", false,
              [ SeriesService.tf({ userCohort: UserCohort.newTFUsers.value, isBot: false }) ]),
          [ StandardReports.calloutOptions("TotalNewUserCounts", [ CalloutLabelService.tf(false, UserCohort.newTFUsers) ],
              true) ],
          StandardReports.sectionOptions('daily-users')
      );
    };

    return {
      conversion: conversion,
      orders: orders,
      sessions: sessions,
      revenue: revenue,
      mau: mau,
      dau: dau,
      spu: spu,
      adoption: adoption,
      newUsers: newUsers
    };

  }
})();